import * as React from 'react';
import styled from 'styled-components';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import {
  DescriptionBlogEditorViewOnlyGrammar,
} from './DescriptionBlogEditorViewOnlyGrammar';
import { SpokePageSpinner } from '@doltech/core/lib/auth/SpokePageSpinner';

const Container = styled.div`
  ${verticalSpace(16)};
  background: ${colorsV2.white100};
  margin: 0 auto;
`;

interface TitleComponentGrammarBlogProps {
  blogTitle?: string;
  blogDescription?: string;
  isLoading?: boolean;
}

export const TitleComponentBlogGrammar = (props: TitleComponentGrammarBlogProps) => {
  const { blogTitle, blogDescription, isLoading } = props;

  if (isLoading) {
    return (
      <Container>
        <SpokePageSpinner/>
      </Container>
    );
  }
  return (
    <Container className="title-component-blog-grammar">
      <header>
        <ResponsiveTypography.Title
          level={1}
          breakpoints={[0, 768]}
          variants={['semi-bold/32-40', 'semi-bold/42-56']}
          color="gray180"
        >
          {blogTitle}
        </ResponsiveTypography.Title>
      </header>
      <DescriptionBlogEditorViewOnlyGrammar
        value={blogDescription}
      />
    </Container>
  );
};

export default TitleComponentBlogGrammar;
